/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Watermark_Date_TimeInputs */



/**
* | output |
* | --- |
* | "Date time" |
*
* @param {Options_Watermark_Date_TimeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_watermark_date_time = /** @type {((inputs?: Options_Watermark_Date_TimeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Watermark_Date_TimeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Date et heure")
	if (locale === "de") return /** @type {LocalizedString} */ ("Datum und Uhrzeit")
	if (locale === "it") return /** @type {LocalizedString} */ ("Data e ora")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Дата и время")
	if (locale === "es") return /** @type {LocalizedString} */ ("Fecha y hora")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("日期时间")
	if (locale === "ja") return /** @type {LocalizedString} */ ("日時")
	if (locale === "hi") return /** @type {LocalizedString} */ ("दिनांक और समय")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Data e hora")
	return /** @type {LocalizedString} */ ("Date time")
});